import React, { Component } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";

class Guarantee extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <HeaderBar {...this.props} />
        <div className="about-page">
          <div className="about-contain">
            <div className="title"></div>
            <div className="about-tent">
              <div className="left">
                <h1>30-Day Guarantee</h1>
              </div>
              <div className="right">
                <h1>Customer Happiness Guarantee</h1>
                <p>
                  Our 30-Day Customer Happiness Guarantee ensures that your
                  plant(s) will arrive happy and healthy. If not, we'll replace
                  them for free.
                </p>
                <p>
                  While it's natural for live plants to show minor signs of
                  stress after transit (and some dirt may slip out of the pot),
                  if the damage is beyond minor blemishes*, reach out to us
                  within 30 days of receipt. To expedite your request, please
                  send photos of the damage, including one close-up pic and one
                  at a distance
                </p>
                <p>
                  The guarantee applies to all online and in-store purchases
                  within the first 30 days. We require photos as proof of damage
                  and to help us improve our packaging process.
                </p>
                <p>
                  <i>
                    *You can help your plant perk up from its journey by gently
                    pruning any foliage damaged during the shipping process,
                    such as bent stems or yellow leaves. Removing damaged
                    foliage gives your plant back energy for new, healthy
                    growth. Need more plant care support? Find additional
                    resources here.
                  </i>
                </p>
              </div>
            </div>
          </div>
        </div>
        <FooterBar {...this.props} />
      </React.Fragment>
    );
  }
}

export default Guarantee;
